import React, { Component } from "react";

class Dashboard extends Component {
  render() {
    return <div>Dashboard page</div>;
  }
}

export default Dashboard;
